import { AxiosResponse, AxiosInstance } from "axios";
import { HubConnection, HubConnectionBuilder } from "@aspnet/signalr";
import { getModule } from "vuex-module-decorators";
import StoreVuexModule from "@/store/StoreVuexModule";
import store from "../store";

interface EventHandler {
  event: string;
  handler: (...args: any[]) => void | Promise<void>;
}

export type ConnectionState = "disconnected" | "connecting" | "connected" | "disconnecting";

export default class SignalRService {
  private axiosInstance: AxiosInstance;

  private connection: HubConnection | null;
  private eventHandlers: EventHandler[];
  private _HUB = "";
  private store = getModule(StoreVuexModule, store);
  private Endpoint: string = this.store.environment.SignalREndpoint;

  public constructor(axiosInstance: AxiosInstance, hubName: string) {
    this.axiosInstance = axiosInstance;
    this.connection = null;
    this.eventHandlers = [];
    this._HUB = hubName;
  }

  public get hub(): string {
    return this._HUB;
  }

  public get clientUrl(): string {
    return `${this.Endpoint}/client/?hub=${this.hub}`;
  }

  public async getToken(): Promise<string | null> {
    const res: void | AxiosResponse<string> = await this.axiosInstance.get<string>(`Signalr/${this.hub}/token`);
    return res.data;
  }

  public async register(): Promise<void> {
    await this.axiosInstance.put<void>(`Signalr/${this.hub}/register`);
    return;
  }

  public async deRegister(): Promise<void> {
    await this.axiosInstance.delete(`Signalr/${this.hub}/deregister`);
    return;
  }

  public async connectHub(): Promise<void> {
    const token = await this.getToken();

    if (token === null) {
      return;
    } else {
      this.connection = new HubConnectionBuilder()
        .withUrl(`${this.clientUrl}`, {
          accessTokenFactory: () => token,
        })
        .build();

      for (const handler of this.eventHandlers) {
        this.connection.on(handler.event, handler.handler);
      }
      try {
        await this.connection.start();
        await this.register();
      } catch (err) {
        // this.connectHub();
        return;
      }
    }
  }

  public async disconnectHub(): Promise<void> {
    if (this.connection === null) {
      return;
    }
    await this.connection.stop();
    await this.deRegister();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public runHandler(event: string, ...args: any[]) {
    const match = this.eventHandlers.find((e) => e.event === event);
    if (match) {
      match.handler.apply(this, args);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public addHandler(event: string, handler: (...args: any[]) => void) {
    let index = this.eventHandlers.findIndex((e) => e.event === event);
    if (index !== -1) {
      return;
    }
    index = this.eventHandlers.push({ event, handler });
    if (this.connection) {
      this.connection.on(event, this.eventHandlers[index].handler);
    }
  }

  public removeHandler(event: string) {
    const index = this.eventHandlers.findIndex((e) => e.event === event);
    if (index === -1) {
      return;
    }
    if (this.connection) {
      this.connection.off(event);
    }
    this.eventHandlers.splice(index, 1);
  }
}
